// extracted by mini-css-extract-plugin
export default {"timer":"Qhu1r","rank":"guokI"};